<!--
 * @Description: 公司
 * @Date: 2025-05-20 18:00:37
-->
<template>
  <div class="account-info__items">
    <BaseTextTitle class="account-info__items__title">公司信息</BaseTextTitle>
    <BaseTextContent class="account-info__content">
      <BaseFormItem label="公司名称" prop="companyName">
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入公司名称"
          disabled
          v-model="formData.companyName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="统一社会信用代码" prop="companyCardNo">
        <BaseInput
          style="width: 100%"
          placeholder="请输入统一社会信用代码"
          disabled
          v-model="formData.companyCardNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="主体类型"
        prop="companyMainType"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          :options="PRINCIPAL_TYPE"
          v-model="formData.companyMainType"
        ></BaseSelect>
      </BaseFormItem>

      <BaseFormItem
        label="公司电话"
        prop="companyPhone"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.companyPhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="证件类型"
        prop="openAccountType"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          :options="OPEN_ACCOUNT_TYPE"
          v-model="formData.openAccountType"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem
        label="对应证件码"
        prop="openAccountCode"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.openAccountCode"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="注册地址"
        prop="companyBusinessAddress"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          show-word-limit
          :maxlength="50"
          v-model="formData.companyBusinessAddress"
        ></BaseInput>
      </BaseFormItem>
      <BizFormTimes
        class="account-info__block"
        label="营业期限"
        startProp="companyBusinessStartAt"
        endProp="companyBusinessEndAt"
        v-model:start="formData.companyBusinessStartAt"
        v-model:end="formData.companyBusinessEndAt"
      />

      <template v-if="['10', '12'].includes(formData.fyChannel)">
        <BaseFormItem
          label="行业类别"
          prop="majorCategory"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
        >
          <!-- 一二级label value都是一样的，三级label value不一样并且反了,统一使用value作为label -->
          <BaseCascader
            style="width: 100%"
            ref="majorCategoryRef"
            key="majorCategory"
            placeholder="请选择"
            clearable
            filterable
            :options="categoryListOption"
            :props="{
              value: 'label',
              label: 'value'
            }"
            v-model="category"
            @change="onCategoryChange"
          ></BaseCascader>
        </BaseFormItem>
        <BaseFormItem label="注册所属省市区" prop="areaCode">
          <BaseCascader
            style="width: 100%"
            ref="areaCodeRef"
            key="areaCode"
            placeholder="请选择"
            clearable
            filterable
            :props="ssqProps"
            v-model="ssq"
            @change="onSsqChange"
          ></BaseCascader>
        </BaseFormItem>
        <BaseFormItem label="注册资本" prop="registeredCapital">
          <BaseInput
            style="width: 100%"
            type="text"
            placeholder="请输入"
            clearable
            inputTextReplace
            v-model="formData.registeredCapital"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem
          label="经营范围"
          prop="businessScope"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请填写'
            }
          ]"
        >
          <BaseInput
            style="width: 100%"
            type="text"
            placeholder="请输入"
            clearable
            show-word-limit
            :maxlength="1000"
            v-model="formData.businessScope"
          ></BaseInput>
        </BaseFormItem>
      </template>

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        label="营业执照"
        prop="companyBusinessLicense"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="companyBusinessLicenseRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('companyBusinessLicense');
              return true;
            }
          "
          v-model:fileList="uploadModelMap.companyBusinessLicense"
          @change="v => onUploadChange(v, 'companyBusinessLicense')"
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照 片，并确保您上传的图片信息内容清
              晰、可辨，单个文件大小不超过 5M； 企业用户需加盖公章
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseSelect,
  BaseCascader,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { getCategoryList, getRegionList } from '../../data-source/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';

const PRINCIPAL_TYPE = [
  { label: '商业公司', value: 1 },
  { label: '个体工商户', value: 2 }
];
const OPEN_ACCOUNT_TYPE = [
  { label: '开户许可证核准号', value: 1 },
  { label: '基本存款账户编号', value: 2 }
];

const { formData, formRef, payPassagewayCode, disabled } = storeToRefs(
  infoStore()
);
const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, ['companyBusinessLicense']);

const majorCategoryRef = ref(null);
const areaCodeRef = ref(null);
const categoryListOption = ref([]); // 行业分类项
const category = ref([]); // 行业分类值 label
const ssq = ref([]); // 所在省市区 label

const ssqProps = {
  lazy: true,
  lazyLoad: async (node, resolve) => {
    const { level, value } = node as any;
    const { data } = await getRegionList({
      level: level + 1,
      parentCode: value || 0,
      payPassagewayCode: payPassagewayCode.value
    });
    const nodes = data.map(item => {
      return { value: item.code, label: item.name, leaf: level >= 2 };
    });
    resolve(nodes);
  }
};

watch(
  () => formData.value,
  v => {
    // 初始数据
    if (v.majorCategory && v.subCategory && v.businessDesc) {
      category.value = [v.majorCategory, v.subCategory, v.businessDesc];
    }
    if (v.areaCode) {
      ssq.value = [v.provinceCode, v.cityCode, v.areaCode];
    }
  },
  { immediate: true, deep: true }
);

const validateField = field => {
  formRef.value.validateField(field);
};
const onCategoryChange = async () => {
  const [nodes] = majorCategoryRef.value.getCheckedNodes();
  const { pathValues } = nodes;
  formData.value.majorCategory = category.value[0];
  formData.value.subCategory = category.value[1];
  formData.value.businessDesc = category.value[2];
  // FIXME: 修改后使用三级code赋值给mcc
  formData.value.mcc = pathValues[2];
  validateField('majorCategory');
};
const onSsqChange = () => {
  const [nodes] = areaCodeRef.value.getCheckedNodes();
  const { pathLabels, pathValues } = nodes;
  formData.value.provinceCode = pathValues[0];
  formData.value.cityCode = pathValues[1];
  formData.value.areaCode = pathValues[2];
  formData.value.provinceName = pathLabels[0];
  formData.value.cityName = pathLabels[1];
  formData.value.areaName = pathLabels[2];
  validateField('areaCode');
};

onMounted(async () => {
  // FIXME: 该接口第三级lable value是反的，组件使用value展示，change后给mcc赋值对应code
  const { data } = await getCategoryList({
    payPassagewayCode: payPassagewayCode.value
  });
  categoryListOption.value = data;
});
</script>
